<template>
  <div id="app">
    <Header
      :displayCart="displayCart"
      :window-width="windowWidth"
      @logOut="handleOnLogOutClick"
      @defaultHome="setDefaultHome"
    />
    <main class="app-content bg-gray">
      <router-view :key="$route.fullPath"></router-view>
    </main>
    <Footer class="footer" />
    <AddressBook v-if="displayAddressBook" />
    <LoadingOverlay v-if="loadOnVetQuit" />
    <Welcome @userAction="handleOnWelcomeAction" v-if="welcomeScreen" />
  </div>
</template>

<script>
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import { mapState, mapGetters } from 'vuex';
import AddressBook from './components/containers/AddressBook';
import LoadingOverlay from '@/components/common/LoadingOverlay';
import Welcome from '@/components/common/Welcome';

export default {
  name: 'App',
  components: {
    Welcome,
    LoadingOverlay,
    AddressBook,
    Footer,
    Header
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  methods: {
    handleOnLogOutClick() {
      this.$store.commit('authModule/logOut');
      window.location.href = '/customer/account/logoutInterface';
    },
    setDefaultHome() {
      this.$store.commit('homeModule/setDisplayMode', 'home');
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
    handleOnWelcomeAction(willContinue) {
      this.$store.commit('homeModule/hideWelcomeScreen', willContinue);
    }
  },
  computed: {
    ...mapState({
      displayCart: state => state.checkOutModule.cart.displayCart,
      displayAddressBook: state =>
        state.authModule.user.token !== '' && state.addressBookModule.display,
      loadOnVetQuit: state => state.homeModule.loadOnVetQuit,
      welcomeScreen: state => state.homeModule.welcomeScreen
    })
  },
  mounted() {
    this.$store.commit('homeModule/setWindowWidth', window.innerWidth);
    window.addEventListener('resize', () => {
      this.$store.commit('homeModule/setWindowWidth', window.innerWidth);
      this.windowWidth = window.innerWidth;
    });
  },
  watch: {
    $route() {
      if (this.displayCart === true) {
        this.$store.commit('checkOutModule/displayCart');
      }
    }
  }
};
</script>

<style lang="sass">
@import '~@/assets/scss/site.scss'

.footer
  flex-shrink: 0
</style>
